import $x from '@/utils/$x';

/**
+ *
+ * @param {*} params
+ * @returns
+ */
export async function getDepartmentList(params) {
  return $x.get(`/department/list`, params);
}

/**
+ * 企业用户列表
+ * @param {*} params
+ * @returns
+ */
export async function getDepartmentUserList(params) {
  return $x.get('/user/list', params);
}

/**
 *
 * @param {*} params
 * @returns
 */
export function queryList(params) {
  return $x.post('/user/queryList', params);
}

/**
 * 企业用户信息同步
 * @param {*} params
 * @returns
 */
export function userAsyc(params) {
  return $x.get('user/sync', params);
}
